export const formatTime = (
  milliseconds,
  content,
  month_cal = false,
  youInheritance = false
) => {
  let seconds = Math.floor(milliseconds / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  let days = Math.floor(hours / 24);
  let weeks = Math.floor(days / 7);
  let months = Math.floor(weeks / 4);
  if (Math.floor(days)===365) months = 12
  if (month_cal && months > 0) {
    return `${months} ${
      months === 1 ? content?.month || "Month" : content?.months || "Months"
    }`;
  }
  if (month_cal && weeks > 0) {
    return `${weeks} ${
      weeks === 1 ? content?.week || "Week" : content?.weeks || "Weeks"
    }`;
  }
  if (days > 0) {
    return `${days} ${
      days === 1 ? content?.day || "Day" : content?.days || "Days"
    }`;
  } else if (hours > 0) {
    return `${hours} ${
      hours === 1 ? content?.hour || "Hour" : content?.hours || "Hours"
    }`;
  } else if (minutes > 0) {
    return `${minutes} ${
      minutes === 1
        ? content?.minute || "Minute"
        : content?.minutes || "Minutes"
    }`;
  } else {
    return `${seconds} ${
      seconds === 1
        ? content?.second || "Second"
        : content?.seconds || "Seconds"
    }`;
  }
};
